import { Base } from "../../framework/base";

export interface IRecordUnit {
    id: string;
    unitId: string;
    title: string;
}

export class RecordUnit implements IRecordUnit {
    id: string;
    unitId: string;
    title: string;

    constructor();
    constructor(obj: IRecordUnit);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.unitId = obj && obj.unitId || "";
        this.title = obj && obj.title || "";
    }

    static sort(items: IRecordUnit[]): IRecordUnit[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IRecordUnit, b: IRecordUnit) => { return (!a || !b) ? 0 : (Base.strCompare(a.title, b.title)); });
    }
}

export class RecordUnitSave {
    id: string;
    unitId: string;

    constructor();
    constructor(obj: IRecordUnit);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.unitId = obj && obj.unitId || "";
    }
}